import { useEffect } from "react";

const DEFAULT_TITLE = "StatementMate — UCAS personal statement feedback";
const DEFAULT_IMAGE = `${window.location.origin}/statementmate-logo.svg`;

function upsertMeta(key, attr, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Client-side SEO/meta management for a CRA SPA. Sets title, description,
// canonical, Open Graph and Twitter Card tags. (Note: social scrapers that
// don't execute JS won't see these — full coverage needs SSR/prerender.)
export function useSeo({ title, description, canonical, image, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · StatementMate` : DEFAULT_TITLE;
    document.title = fullTitle;
    const img = image || DEFAULT_IMAGE;
    const url = canonical || window.location.href;

    upsertMeta("description", "name", description || "");
    upsertLink("canonical", url);

    upsertMeta("og:title", "property", title || DEFAULT_TITLE);
    upsertMeta("og:description", "property", description || "");
    upsertMeta("og:type", "property", type);
    upsertMeta("og:url", "property", url);
    upsertMeta("og:image", "property", img);
    upsertMeta("og:site_name", "property", "StatementMate");

    upsertMeta("twitter:card", "name", "summary_large_image");
    upsertMeta("twitter:title", "name", title || DEFAULT_TITLE);
    upsertMeta("twitter:description", "name", description || "");
    upsertMeta("twitter:image", "name", img);

    return () => {
      document.title = DEFAULT_TITLE;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, canonical, image, type]);
}
